import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';

/**
 * @param {Class<TicketConfiguration>}  ticketConfiguration         Required - Ticket configuration model
 * @param {Array<TicketCategories>}     ticketCategories            Required - Exisitng categories
 * @param {Task}                        showCreateTicketModalTask   Required - Task that controls the modal
 */
let CreateCategoryModalComponent = (_class = class CreateCategoryModalComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "flashMessages", _descriptor, this);
    _initializerDefineProperty(this, "metrics", _descriptor2, this);
    _initializerDefineProperty(this, "store", _descriptor3, this);
    _initializerDefineProperty(this, "newCategoryName", _descriptor4, this);
    _initializerDefineProperty(this, "categoryNameError", _descriptor5, this);
    _defineProperty(this, "createCategoryTask", _buildTask(() => ({
      context: this,
      generator: function* (closeModal) {
        const {
          showCreateTicketModalTask,
          ticketConfiguration
        } = this.args;
        if (!this.newCategoryName) {
          this.categoryNameError = ['Please enter a category name'];
        } else if (this.isDuplicateName()) {
          this.categoryNameError = ['Category name already exists'];
        }
        if (!this.categoryNameError.length) {
          const ticketCategory = this.store.createRecord('ticket-category', {
            ticketConfiguration,
            name: this.newCategoryName
          });
          try {
            yield ticketCategory.save();
            this.metrics.trackEvent('Ticketing category created', {
              locationId: ticketConfiguration.belongsTo('location').id(),
              categoryName: this.newCategoryName
            });
            this.flashMessages.showAndHideFlash('success', 'Category created successfully!');
          } catch (e) {
            this.flashMessages.showAndHideFlash('error', 'Error', parseErrorForDisplay(e));
          }
          this.newCategoryName = '';
          this.categoryNameError = [];
          if (closeModal) {
            const createTask = showCreateTicketModalTask.last;
            createTask.continue();
          }
        }
      }
    }), {
      drop: true
    }, "createCategoryTask", null));
    _defineProperty(this, "createCategoryAndCloseTask", _buildTask(() => ({
      context: this,
      generator: function* (e) {
        e.preventDefault();
        yield this.createCategoryTask.perform(true);
      }
    }), {
      drop: true
    }, "createCategoryAndCloseTask", null));
  }
  inputInserted(element) {
    element.focus();
  }
  onCancel() {
    const {
      showCreateTicketModalTask
    } = this.args;
    this.newCategoryName = '';
    this.categoryNameError = [];
    const createTask = showCreateTicketModalTask.last;
    createTask.abort();
  }
  onCategoryNameChange(name) {
    this.newCategoryName = name;
    if (this.isDuplicateName()) {
      this.categoryNameError = ['Category name already exists'];
    } else {
      this.categoryNameError = [];
    }
  }
  isDuplicateName() {
    const {
      ticketCategories
    } = this.args;
    return ticketCategories.any(category => category.name.toLowerCase() === this.newCategoryName.toLowerCase());
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "metrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "newCategoryName", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "categoryNameError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "inputInserted", [action], Object.getOwnPropertyDescriptor(_class.prototype, "inputInserted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCancel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onCancel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCategoryNameChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onCategoryNameChange"), _class.prototype)), _class);
export { CreateCategoryModalComponent as default };